import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import CertificationExam from "../Components/Dashboard/CertificationExam";
import Swal from 'sweetalert2'
const AuthCertificationexam = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  
  if (auth) {
    const batchId = Number(localStorage.getItem("batch_id"));
    const categoryId = Number(localStorage.getItem("category"));
    if (batchId > 125 && [2, 4, 11, 27, 35, 36].includes(categoryId)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return auth ? <CertificationExam /> : <>
  {
     Swal.fire({
      title: "Timeout",
      text: "Your Session has been expired please relogin",
      icon: "info",
      confirmButtonText: "Ok"
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href="https://accredian.com"
      }
    })
  }
  </>
}
export default AuthCertificationexam;
